

























































import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import {
    pageData
} from "@/store/pageData";
import {
    TimelineMax,
    TweenLite,
    Power1,
    TweenMax,
    Expo,
    Power2,
    Power3,
    Power4
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from 'scrollmagic';
@Component({
    name: "NewsDetailPage",
})
export default class NewsDetailPage extends Vue {
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    public HOST: string = HOST;

    public heroimganim(): void {
        const {
            imgoverlay
        } = (this as any).$refs
        TweenLite.delayedCall(1.5, overlay);

        function overlay() {
            TweenMax.to(imgoverlay, .3, {
                opacity: .4,
                ease: Power2.easeOut
            });
        }
        var heroimganim: any = new TimelineMax({});
        heroimganim
            .to(imgoverlay, .01, {
                opacity: 0,
            })

            .staggerFrom(".banner-wrap img", .8, {
                delay: .2,
                autoAlpha: 0,
                scale: 1.5,
                height: 100,
                y: 600,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.1)
            .to('.banner-text', .01, {
                overflow: 'hidden'
            })
            .staggerFrom('.banner-text h1', .6, {
                autoAlpha: 0,
                y: 80,
                ease: Power1.easeOut,
                clearProps: 'all'
            }, .1, '-=.05')
            .staggerFrom('.banner-text p', .6, {
                autoAlpha: 0,
                y: 80,
                ease: Power1.easeOut,
                clearProps: 'all'
            }, .2, '-=.3')
            .to('.banner-text', .01, {
                clearProps: 'all'
            });

    }
    public mounted() {
        this.heroimganim();
        const cont = new ScrollMagic.Controller();
        const tl = new TimelineMax()
            .staggerFrom('.newstitle-block h2', 1, {
                y: 50,
                opacity: 0,
                clearProps: 'all'
            }, 0.2)
            .staggerFrom('.author p', 1, {
                y: 30,
                opacity: 0,
                clearProps: 'all'
            }, 0.2, 0.2)

        const text = new ScrollMagic.Scene({
                triggerElement: '.newstitle-header',
                offset: -20,
                reverse: false
            })
            .setTween(tl)
            .addTo(cont);

        const tl1 = new TimelineMax()
            .staggerFrom('.news-richtext', .7, {
                y: 80,
                force3D: true,
                autoAlpha: 0,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.2)
            // .staggerFrom('.full-width', 1, {
            //     scale: .8,
            //     y: '10%',
            //     opacity: 0,
            //     ease: Power3.easeIn,
            //     clearProps: 'all'
            // }, 0.2, 0.2)
            // .staggerFrom('.news-richtext h2', 1, {
            //     y: 30,
            //     opacity: 0
            // }, 0.2, 0.6)
            // .staggerFrom('.right', 1, {
            //     scale: .8,
            //     x: '50%',
            //     opacity: 0,
            //     ease: Power1.easeIn,
            //     clearProps: 'all'
            // }, 0.2, 0.8);

        const controller = new ScrollMagic.Controller();

        const scene = new ScrollMagic.Scene({
                triggerElement: ".news-richtext",
                reverse: false,
                // duration: 1000,
                //triggerHook: "onEnter"
                offset: 300
            })
            .setTween(tl1)
            .addTo(controller);


    }
}
